import { includes } from "lodash";

const dateTypes = ["date"];

const isDateType = (type) => includes(dateTypes, type);

export { isDateType };
